module.exports = __webpack_public_path__ + "static/media/SummaryCh1&2_A01378565.e2fb946e.pdf";